import { store } from "@betacrew/jars-flux";
import { all, put, takeLeading } from "redux-saga/effects";
import { componentKey, setBillingDetails, setCurrentPaymentStep, setLoadingState, setPayNowCbLoadingState, setPaymentSuccessDetails, setPrepaySalesTaxAmount, setSavedAddress } from "./PaymentDrawerSlice";
import { PAGE_STATE } from "../../constants/constants";
import PaymentDataService from "../../../../services/PaymentDataService";
import { PAYMENT_DRAWER_LOADING_STATES, PAYMENT_STEPS } from "./constants";
import { addNotifications } from "../../toaster/ToasterPortalSlice";
import { TOASTER_VARIANT } from "../../../components/toast/constants";
import { setPrepayAmount } from "../../loaders/dataloader/DataLoaderSlice";

export const { paynow, applyCoupon, getPrepaySalesTax, getPrepayAmount, getSavedAddress } = {

    paynow: (payload) => {
        return {
            type: "PAYMENT_DRAWER/PAYNOW",
            payload
        }
    },

    applyCoupon: (payload) => {
        return {
            type: "PAYMENT_DRAWER/APPLY_COUPON",
            payload
        }
    },

    getPrepaySalesTax: (payload) => {
        return {
            type: "PAYMENT_DRAWER/GET_PREPAY_SALES_TAX",
            payload
        }
    },

    getPrepayAmount: (payload) => {
        return {
            type: "PAYMENT_DRAWER/GET_PREPAY_AMOUNT",
            payload
        }
    },

    getSavedAddress: (payload) => {
        return {
            type: "PAYMENT_DRAWER/GET_SAVED_ADDRESS",
            payload
        }
    },

}

function* paynowAsync(action) {
    try {
        yield put(setPayNowCbLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.PAY_NOW_LOADING, message: "Loading" }));

        const { billingDetails, paymentServiceFunctionCb, onPaymentSuccessCb, paymentServiceFunctionExtraParams = {}, card_id = "", saveCardDetails = false, placeOfOriginforpayment, addressDetails = {}, amount = 0, Customer = undefined, isAddressSave = false, CardNumber= "", CommonCreditCardNumber="" } = action.payload;
        const requestPayload = {
            ...paymentServiceFunctionExtraParams,
            TotalAmount: card_id ? Number(Number(amount).toFixed(2)) : Number(Number(billingDetails?.FinalFilingFee).toFixed(2)) || 0,
            Coupon: billingDetails?.Coupon,
            CardNumber: CardNumber,
            Name: addressDetails?.name || "",
            Email: "",
            SaveCard: saveCardDetails,
            SaveCardId: "",
            SalesTaxAmount1: billingDetails?.EstimatedTax || 0,
            UspsMailingAmount: billingDetails?.USPSFee || 0,
            IsSeparateStateFilingPayment: billingDetails?.OnlySeparateStatefiling == "true" ? true : false,
            IsPrepaid: card_id ? false : true, //Boolean,
            isPrepaid: `${card_id ? "false" : "true"}`, //String
            placeOfOriginforpayment,
            CommonIsSavedCard: saveCardDetails,
            CommonSavedCard: null,
            PaymentMethodId: card_id,
            Card_Id: card_id,
            Customer_Id: Customer || undefined,
            isSaveAddress: isAddressSave,
            CommonBillingaddress : addressDetails?.address?.line1 || "", 
            CommonCity: addressDetails?.address?.city || "", 
            CommonState: addressDetails?.address?.state || "", 
            CommonCountry: addressDetails?.address?.country || "", 
            CommonZipcode: addressDetails?.address?.postal_code || "",
            CommonCreditCardNumber: CommonCreditCardNumber,
        }

        const response = yield paymentServiceFunctionCb(requestPayload);
        const { Status, Message, Data } = response?.data;

        if (Status) {
            yield put(setPaymentSuccessDetails({
                amountPaid: Number((Number(billingDetails?.TotalFilingFee) + Number(billingDetails?.EstimatedTax) - Number(billingDetails?.DiscountAmount || 0)).toFixed(2)),
                referenceId: Data?.ReferenceId || "",
                message: Message,
            }))
            yield put(setCurrentPaymentStep(PAYMENT_STEPS.PAYMENT_SUCESS));
            yield put(getPrepayAmount());
            onPaymentSuccessCb();
        } else {
            yield put(addNotifications({ heading: "Failed to do the payment", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to do the payment", message: error?.response?.data?.Message }));
    } finally {
        yield put(setPayNowCbLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.PAY_NOW_READY }))
    }
}

function* applyCouponAsync(action) {
    try {
        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.APPLY_COUPON_LOADING }));

        const { coupon, filingFee, totalFilingFee } = action.payload;

        const response = yield PaymentDataService.getDiscountCoupon({ coupon, filingFee });
        const { Status, Message, Data } = response?.data;

        if (Status) {
            const newTotalAmount = Number((Number(totalFilingFee) - Number(Data)).toFixed(2));
            yield put(setBillingDetails({ DiscountAmount: Data, FinalFilingFee: newTotalAmount }));
            yield put(addNotifications({ heading: "Success", message: "The coupon has been applied successfully", variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: error?.response?.data?.Message, message: "Failed to apply the coupon" }));
    } finally {
        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.APPLY_COUPON_READY }))
    }
}

function* getPrepaySalesTaxAsync(action) {
    try {
        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.CALCULATE_PREPAY_SALES_TAX_LOADING, message: "Loading..." }));
        const { totalAmount, isUsps } = action?.payload;

        const response = yield PaymentDataService.getPrepaySalesTaxAmount(totalAmount, isUsps);
        const { Status, Message, Data } = response?.data;

        if (Status) {
            const totalTax = Number(Data?.data?.totalTax || 0);
            yield put(setPrepaySalesTaxAmount(totalTax));
            yield put(setBillingDetails({ EstimatedTax: totalTax }))
        } else {
            yield put(addNotifications({ heading: "Failed to get prepay sales tax amount", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to get prepay sales tax amount", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.CALCULATE_PREPAY_SALES_TAX_READY }))
    }
}

function* getPrepayAmountAsync(action) {
    try {
        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.GET_PREPAY_AMOUNT_LOADING, message: "Fetching Prepay Amount" }));

        const response = yield PaymentDataService.getPrepaidAmount();

        if (response?.data) {
            const { Data, Message, Status } = response?.data;

            if (Status) {
                yield put(setPrepayAmount(Data));
            } else {
                yield put(addNotifications({ heading: "Failed to get the Prepaid Amount", message: Message }));
            }
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the Prepaid Amount", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.GET_PREPAY_AMOUNT_READY }))
    }
}

function* getSavedAddressAsync(action) {
    try {
        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.GET_PREPAY_AMOUNT_LOADING, message: "Fetching Prepay Amount" }));

        const response = yield PaymentDataService.getSavedAddress();

        if (response?.data) {
            const { Data, Message, Status } = response?.data;

            if (Status === 1) {
                yield put(setSavedAddress(Data));
                
            } else {
                yield put(addNotifications({ heading: "Failed to get saved addresses", message: Message }));
            }
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get saved addresses", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAYMENT_DRAWER_LOADING_STATES.GET_PREPAY_AMOUNT_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLeading(paynow().type, paynowAsync),
        takeLeading(applyCoupon().type, applyCouponAsync),
        takeLeading(getPrepaySalesTax().type, getPrepaySalesTaxAsync),
        takeLeading(getPrepayAmount().type, getPrepayAmountAsync),
        takeLeading(getSavedAddress().type, getSavedAddressAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);